import { render, staticRenderFns } from "./FeCarlosMaximiliano.vue?vue&type=template&id=67aa0f9a&"
import script from "./FeCarlosMaximiliano.vue?vue&type=script&lang=js&"
export * from "./FeCarlosMaximiliano.vue?vue&type=script&lang=js&"
import style0 from "./FeCarlosMaximiliano.vue?vue&type=style&index=0&id=67aa0f9a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports